document.addEventListener("DOMContentLoaded", () => {
  // Adds a loaded attribute to lazy loaded images when they are loaded
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  lazyImages.forEach((img) => {
    img.setAttribute("loaded", img.complete ? "true" : "false");
    img.onload = () => {
      img.setAttribute("loaded", "true");
    };
  });
});
